/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.Model = M.Model || {};
  M.Model.Design = M.Model.Design || {};

  /**
   * @class M.Model.Design.PollOption
   * A design poll has 4 poll options representing 4 different variations of a
   * design that are being voted on
   */
  M.Model.Design.PollOption = Backbone.Model.extend({
    defaults: {
      percent: 0,
    },

    toJSON: function() {
      if (!this.isBlank()) {
        return {
          id: this.id,
          image: this.get('image'),
          thumb: this.get('thumb')
        };
      } else {
        return null;
      }
    },

    isBlank: function() {
      return !this.id && !this.get('image') && !this.get('thumb');
    }
  });

})(M, _, $, Backbone);
